@if (!(IsAddMode && Column.DisplayOnNewItemCreation === false)) {
  <ng-container [formGroup]="Form">
    @if (Column.DataType === 'date') {
      <div>
        <input placeholder="yyyy-mm-dd" name="dp" id="{{Column.ColumnName}}" type="date" class="form-control"
          maxlength="{{Column.Maxlength}}" size="{{Column.Size}}" name="{{Column.ColumnName}}" formControlName="{{Column.ColumnName}}"
          (dateSelect)="onChange(this,$event)" max="9999-12-31">
        </div>
      }
      @if (Column.DataType === 'string' || Column.DataType === 'anchor') {
        <input [ngClass]="{'multiline-cell': Column.IsMultiLine}"  size="{{Column.Size}}" id="{{Column.ColumnName}}" maxlength="{{Column.Maxlength}}" type="text" name="{{Column.ColumnName}}"
          formControlName="{{Column.ColumnName}}" (change)="onChange(this,$event)"> {{CurrencySymbol}}
        }
        @if (Column.DataType === 'number') {
          {{CurrencySymbol}}
          <input size="{{Column.Size}}" [form]="Form" [maxNumberOfIntegers]='Column.MaxNumberOfIntegrsAllowed'
            [maxNumberOfDecimals]='Column.MaxNumberOfDecimalsAllowed' id="{{Column.ColumnName}}" maxlength="{{Column.Maxlength}}"
            type="text" appNumberOnly name="{{Column.ColumnName}}" formControlName="{{Column.ColumnName}}" (change)="onChange(this,$event)">
          }
          @if (Column.DataType === 'list') {
            <select id="{{Column.ColumnName}}" name="{{Column.ColumnName}}" formControlName="{{Column.ColumnName}}" [value]="Value"
              (change)="onChange(this,$event)">
              <option value="null">
                {{resources.None}}
              </option>
              @if (IsAddMode) {
                @for (selectItem of Column.NewItemListItems | async; track selectItem) {
                  <option value="{{selectItem.Value}}">
                    {{selectItem.Text}}
                  </option>
                }
              }
              @if (IsEditMode) {
                @for (selectItem of Column.EditItemListItems | async; track selectItem) {
                  <option value="{{selectItem.Value}}">
                    {{selectItem.Text}}
                  </option>
                }
              }
            </select>
          }
        </ng-container>
      }